import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import {
  Form,
  InputPlaceholder,
  TextareaPlaceholder,
  CheckboxGroupPlaceholder,
  Subtext,
  Row,
  SectionDivider,
  ActionsWrapper
} from '@contently/toolkit';
import DirectAttachmentUpload, {
  useDirectAttachmentUploadFormik
} from '../forms/active_storage_direct_uploader';
import QuestionsContainer from './questions_container';

const onDragEnd = (result, arrayHelpers) => {
  if (!result.destination) {
    return;
  }
  arrayHelpers.move(result.source.index, result.destination.index);
};

const onDelete = (index, arrayHelpers) => {
  arrayHelpers.remove(index);
};

function ContentRequestForm(props) {
  const {
    streamingData,
    setValues,
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isFetching,
    setFieldValue
  } = props;

  useEffect(() => {
    if (streamingData) setValues(streamingData);
  }, [streamingData, setValues]);

  const [isUploading, uploaderProps] = useDirectAttachmentUploadFormik(props);

  const { brandProfileId } = values || {};

  return (
    <form onSubmit={handleSubmit} data-parsley-excluded="true">
      <SectionDivider>
        <Row>
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
            ready={!isFetching}
          >
            <Form.Label required htmlFor="name">
              Name
            </Form.Label>
            <Form.ErrorWrapper touched={touched.name} error={errors.name}>
              <Form.Input
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                name="name"
                id="name"
                placeholder="Give your content request form a name"
                required
              />
            </Form.ErrorWrapper>
          </ReactPlaceholder>
        </Row>

        <Row>
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<TextareaPlaceholder wrapperClass="row" withLabel />}
            ready={!isFetching}
          >
            <Form.ErrorWrapper touched={touched.instructions} error={errors.instructions}>
              <Form.MarkdownPreviewTextarea
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.instructions}
                name="instructions"
                id="instructions"
                placeholder="Instructions..."
              />
            </Form.ErrorWrapper>
          </ReactPlaceholder>
        </Row>

        <Row>
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<CheckboxGroupPlaceholder withLabel checkboxes={2} />}
            ready={!isFetching}
          >
            <Form.Label htmlFor="optional-fields">Optional fields</Form.Label>
            <Form.Checkbox
              id="includeAudience"
              label="Audience"
              value="includeAudience"
              checked={values.includeAudience}
              onChange={value => {
                setFieldValue('includeAudience', value);
              }}
            />

            <Form.Checkbox
              id="includePillar"
              label="Pillar"
              value="includePillar"
              checked={values.includePillar}
              onChange={value => {
                setFieldValue('includePillar', value);
              }}
            />
          </ReactPlaceholder>
        </Row>

        <Row>
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<TextareaPlaceholder wrapperClass="row" withLabel />}
            ready={!isFetching}
          >
            <Form.Label htmlFor="file">Additional material</Form.Label>
            <Subtext>Upload a sample form or an additional material.</Subtext>
            <div className="row-fourth">
              <Form.ErrorWrapper touched error={errors.file}>
                <DirectAttachmentUpload {...uploaderProps} />
              </Form.ErrorWrapper>
            </div>
          </ReactPlaceholder>
        </Row>
      </SectionDivider>

      <SectionDivider>
        <QuestionsContainer
          questions={values.questions}
          onDragEnd={onDragEnd}
          onDelete={onDelete}
          setFieldValue={setFieldValue}
          isFetching={isFetching}
        />
      </SectionDivider>

      <ActionsWrapper>
        <Form.CancelLinkButton href={`/publications/${brandProfileId}/content_request_forms`} />
        <Form.ButtonWithProgress
          type="submit"
          disabled={isSubmitting || isUploading}
          variant="primary"
        >
          Save
        </Form.ButtonWithProgress>
      </ActionsWrapper>
    </form>
  );
}

ContentRequestForm.defaultProps = {
  isSubmitting: false,
  isFetching: false,
  streamingData: null
};

ContentRequestForm.propTypes = {
  streamingData: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool,
  isFetching: PropTypes.bool
};

export default ContentRequestForm;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_request_forms/content_request_form.jsx